import ClientService from '../../../../services/client-service';
import changePasswordMutation from '../../../../graphql/mutation/change-password.graphql';

export default class PasswordRecoveryApi {
  public static changePassword(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(changePasswordMutation, payload);
  }
}
